<template>
  <section class="infraestructura">
    <p class="titleColorSystem">Oferta de Servicios</p>
    <div class="sci-inf-content">
      <table class="sci-inf-table">
        <thead class="sci-inf-thead">
          <v-flex md5 xs12>
            <v-select
              v-model="typeOfSearch"
              :items="typesOfSearch"
              item-value="id"
              class="text-xs-center"
              item-text="name"
              label="Buscar por..."
            >
            </v-select>
          </v-flex>
          <v-flex md5 xs12 v-if="typeOfSearch == 1">
            <v-select
              v-model="typeOfService"
              :items="typesOfServices"
              item-value="name"
              class="text-xs-center"
              item-text="name"
              label="Servicios..."
              @change="selectService()"
            >
            </v-select>
          </v-flex>
          <v-flex d-flex xs12 sm12 md5 v-if="typeOfSearch == 2">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar nombre, tipo de servicio, descripcion, palabra clave..."
              clearable
              flat
              @click:clear="limpiarCampos(page)"
              :hint="`Se Encontraron
                ${infCount ? infCount : 0}
                Resultados`"
              @keyup.enter.native="
                getServicios(page, search), getServiciosExcel(page, search)
              "
            ></v-text-field>
          </v-flex>

          <span class="sci-inf-count">
            <vue-excel-xlsx
              v-if="servicios.data.length > 0"
              class="sci-inf-excel"
              :data="serviciosExcelData"
              :columns="columns"
              :filename="'Oferta de servicios'"
              :sheetname="'Oferta de servicios'"
            >
              Descargar resultados
            </vue-excel-xlsx>
          </span>
          <tr class="sci-inf-tr1-servicio">
            <td>Institución</td>
            <td>Nombre del servicio</td>
            <td>Tipo de Servicio</td>
            <td>Ubicación</td>
            <td>Precio</td>
            <td></td>
            <td>Contacto</td>
          </tr>
        </thead>
        <span v-if="!infCount">
          <h3 class="font-weight-thin mb-3">SIN INFORMACIÓN</h3>
          <h4 class="subheading">POR FAVOR REALICE UNA BÚSQUEDA</h4>
        </span>
        <tbody v-else id="tbody" class="sci-inf-tbody">
          <tr v-for="(servicio, index) in servicios.data" :key="index">
            <span class="sci-inf-tr2-servicio">
              <td class="sci-inf-tr2-td">
                {{
                  servicio.institucion_academica
                    ? servicio.institucion_academica.nombre
                    : ""
                }}
              </td>
              <td class="sci-inf-tr2-td">
                {{ servicio.nombre ? servicio.nombre : "" }}
              </td>
              <td class="sci-inf-tr2-td">
                {{ servicio.tipo_servicio ? servicio.tipo_servicio : "" }}
              </td>
              <td class="sci-inf-tr2-td">
                {{ servicio.ubicacion ? servicio.ubicacion : "" }}
              </td>
              <td class="sci-inf-tr2-td">
                {{ servicio.precio ? servicio.precio : "" }}
              </td>
              <td class="sci-inf-tr2-td">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      v-on="on"
                      flat
                      @click.stop="$set(dialogNote, servicio.id, true)"
                    >
                      Ver mas
                    </v-btn>
                  </template>
                  <span>Click para ver mas información</span>
                </v-tooltip>

                <v-dialog
                  v-model="dialogNote[servicio.id]"
                  scrollable
                  lazy
                  max-width="500"
                  max-height="600"
                  :key="servicio.id"
                >
                  <v-card>
                    <v-card-title class="justify-content-center">
                      <span class="grey--text">{{
                        servicio.institucion_academica
                          ? servicio.institucion_academica.nombre
                          : ""
                      }}</span>
                      <span class="headline">{{ servicio.nombre }}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-flex>
                        <v-textarea
                          readonly
                          label="Descripción del servicio"
                          v-model="servicio.descripcion"
                        ></v-textarea>
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          label="Tipo de capacitación"
                          readonly
                          v-model="servicio.tipo_capacitacion"
                        ></v-text-field>
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          label="Matriz"
                          readonly
                          v-model="servicio.matriz"
                        ></v-text-field>
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          label="Referencia método"
                          readonly
                          v-model="servicio.referencia_metodo"
                        ></v-text-field>
                      </v-flex>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        @click.stop="$set(dialogNote, servicio.id, false)"
                        >Cerrar</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </td>
              <td class="sci-inf-tr2-td">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      color="primary"
                      v-on="on"
                      flat
                      @click.stop="$set(dialogContact, servicio.id, true)"
                    >
                      <v-icon>person</v-icon>
                    </v-btn>
                  </template>
                  <span>Click para contactar al responsable</span>
                </v-tooltip>

                <v-dialog
                  v-model="dialogContact[servicio.id]"
                  scrollable
                  lazy
                  max-width="500"
                  max-height="600"
                  :key="servicio.id"
                >
                  <v-card>
                    <v-card-title class="justify-content-center">
                      <span class="grey--text">{{
                        servicio.institucion_academica
                          ? servicio.institucion_academica.nombre
                          : ""
                      }}</span>
                      <!-- <span class="headline">Contacto:</span> -->
                    </v-card-title>
                    <v-card-text>
                      <v-avatar size="100" color="white">
                        <v-icon size="80">account_circle</v-icon>
                      </v-avatar>
                      <br />
                      <br />
                      <span class="title primary--text"
                        >{{ servicio.nombre_responsable }}
                        {{ servicio.ap_pat_responsable }}
                        {{ servicio.ap_mat_responsable }}</span
                      >
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        :disabled="!servicio.telefono"
                        :href="`tel:${servicio.telefono}`"
                        flat
                        color="green"
                        block
                        ><v-icon left>call</v-icon>Llamar</v-btn
                      >
                      <SentMailToRepresentante
                        slot="activator"
                        v-bind:representante_nombre="
                          servicio.nombre_responsable
                        "
                        v-bind:representante_apellido_paterno="
                          servicio.ap_pat_responsable
                        "
                        v-bind:representante_apellido_materno="
                          servicio.ap_mat_responsable
                        "
                        v-bind:representante_email="servicio.correo"
                      ></SentMailToRepresentante>
                    </v-card-actions>
                    <v-btn
                      color="primary"
                      block
                      large
                      @click.stop="$set(dialogContact, servicio.id, false)"
                      >Cerrar</v-btn
                    >
                  </v-card>
                </v-dialog>
              </td>
            </span>
          </tr>
        </tbody>
        <v-spacer></v-spacer>
        <div class="pagination justify-content-center">
          <pagination
            :limit="vPaginator.limit"
            :data="servicios"
            @pagination-change-page="getServicios"
          ></pagination>
        </div>
      </table>
    </div>
    <LoadingComponent :loading="dialogLoading"></LoadingComponent>
  </section>
</template>

<script>
import axios from "axios";
import SentMailToRepresentante from "./SentMailToRepresentante.vue";
import LoadingComponent from "../../components/LoadingDialog.vue";
export default {
  props: ["urlApi"],
  components: {
    SentMailToRepresentante,
    LoadingComponent,
  },
  data() {
    return {
      typeOfService: "",
      typeOfSearch: {},
      typesOfSearch: [
        { id: 1, name: "Tipo de Servicio" },
        { id: 2, name: "Palabra clave" },
      ],
      typesOfServices: [
        { id: 1, name: "Asesoría" },
        { id: 2, name: "Capacitación" },
        { id: 3, name: "Servicios de laboratorio" },
        { id: 4, name: "Incubadora" },
        { id: 5, name: "Transferencia tecnológica" },
        { id: 6, name: "Consultoría" },
        { id: 7, name: "Prácticas profesionales" },
        { id: 8, name: "Arrendamiento de espacio e infraestructura" },
        { id: 9, name: "Desarrollo de nuevos productos" },
      ],
      dialogContact: {},
      dialogNote: {},
      dialogLoading: false,
      page: 1,
      columns: [
        { label: "Institución", field: "institucion_nombre" },
        { label: "Nombre del servicio", field: "nombre" },
        { label: "Tipo del servicio", field: "tipo_servicio" },
        { label: "Ubicacion", field: "ubicacion" },
        { label: "Matriz", field: "matriz" },
        { label: "Nombre del responsable", field: "nombre_responsable" },
        { label: "Primer apellido", field: "ap_pat_responsable" },
        { label: "Segundo apellido", field: "ap_mat_responsable" },
        { label: "Descripcion", field: "descripcion" },
        { label: "Telefono del responsable", field: "telefono" },
        { label: "Correo del responsable", field: "correo" },
        { label: "Precio", field: "precio" },
        { label: "Referencia método", field: "referencia_metodo" },
      ],
      search: null,
      load: 1,
      servicios: {
        current_page: 1,
        data: {
          servicios: [],
        },
      },
      serviciosExcel: {},
      vPaginator: {
        limit: 10,
      },
      selected: 4,
      CurrentElement: {},
    };
  },
  created() {
    // this.getInfraestructura();
    // this.getInfraestructuraExcel();
    // this.limpiarCampos();
  },
  watch: {
    // search: function (value) {
    //   this.getInfraestructuras();
    //   this.getInfraestructurasExcel();
    // },
  },
  computed: {
    infCount() {
      return this.servicios.total;
    },
    serviciosExcelData() {
      let servicios = [];
      if (this.serviciosExcel.data) {
        this.serviciosExcel.data.forEach((element) => {
          let servicio = {
            institucion_nombre: element.institucion_academica
              ? element.institucion_academica.nombre
              : "",
            nombre: element.nombre ? element.nombre : "",
            tipo_servicio: element.tipo_servicio ? element.tipo_servicio : "",
            tipo_capacitacion: element.tipo_capacitacion
              ? element.tipo_capacitacion
              : "",
            ubicacion: element.ubicacion ? element.ubicacion : "",
            ap_pat_responsable: element.ap_pat_responsable
              ? element.ap_pat_responsable
              : "",
            ap_mat_responsable: element.ap_mat_responsable
              ? element.ap_mat_responsable
              : "",
            nombre_responsable: element.nombre_responsable
              ? element.nombre_responsable
              : "",
            telefono: element.telefono ? element.telefono : "",
            correo: element.correo ? element.correo : "",
            precio: element.precio ? element.precio : "",
            matriz: element.matriz ? element.matriz : "",
            referencia_metodo: element.referencia_metodo
              ? element.referencia_metodo
              : "",
            descripcion: element.descripcion ? element.descripcion : "",
          };
          servicios.push(servicio);
        });
      }

      return servicios;
    },
  },
  methods: {
    selectService(page = 1) {
      this.dialogLoading = true;
      var urlServicios = process.env.VUE_APP_API_URL + `/api/servicios?page=${page}&query=${this.typeOfService}`;
      axios
        .get(urlServicios)
        .then((response) => {
          this.servicios = response.data;
        })
        .catch((error) => console.log("Error ", error));
      var urlServiciosOutPage = process.env.VUE_APP_API_URL +  `/api/servicios?perPage=200&page=1&query=${this.typeOfService}`;
      axios
        .get(urlServiciosOutPage)
        .then((response) => {
          this.serviciosExcel = response.data;
        })
        .catch((error) => console.log("Error ", error))
        .finally(() => (this.dialogLoading = false));
    },
    getServicios: function (page = 1) {
      this.dialogLoading = true;
      var url = process.env.VUE_APP_API_URL + `/api/servicios?page=${page}&query=${this.search}`;
      axios
        .get(url)
        .then((response) => {
          this.servicios = response.data;
        })
        .catch((error) => console.log("Error ", error))
        .finally(() => (this.dialogLoading = false));
    },
    getServiciosExcel: function (page = 1) {
      var url = process.env.VUE_APP_API_URL +  `/api/servicios?perPage=200&page=1&query=${this.search}`
      axios
        .get(url)
        .then((response) => {
          this.serviciosExcel = response.data;
        })
        .catch((error) => console.log("Error ", error));
    },

    limpiarCampos(page) {
      this.search = null;
      this.getServicios(page), this.getServiciosExcel(page);
    },
  },
};
</script>

<style>
.sci-inf-title {
  margin: 3% auto 0%;
  text-transform: uppercase;
  color: rgba(255, 196, 0, 0.9);
  font-weight: bold;
  font-size: 1.5em;
}
.sci-inf-dot {
  font-weight: bold;
  color: rgba(0, 152, 255, 0.9);
}
.sci-inf-dot:before {
  content: "";
  display: inline-block;
  width: 90px;
  height: 1px;
  background: rgba(0, 0, 0, 0.5);
  margin-right: 1.2%;
  border-radius: 1px 1px;
}
.sci-inf-dot:after {
  content: "";
  display: inline-block;
  width: 90px;
  height: 1px;
  background: rgba(0, 0, 0, 0.5);
  margin-left: 1.2%;
  border-radius: 0 0 0 0;
}
.sci-inf-texto {
  width: 50%;
  margin: 1% auto;
  line-height: 1.5;
}
.sci-inf-content {
  display: grid;
  grid-template-areas:
    "sci-inf-table sci-inf-show"
    "sci-inf-table sci-inf-show"
    "sci-inf-table sci-inf-show"
    "sci-inf-table sci-inf-show"
    "sci-inf-table sci-inf-show"
    ". sci-inf-show"
    ". sci-inf-show"
    ". sci-inf-show"
    ". sci-inf-show"
    ". sci-inf-show"
    ". sci-inf-show";
  grid-template-columns: 1fr;
  margin: 0 0 4% 0;
}
.sci-inf-table {
  display: grid;
  grid-area: sci-inf-table;
  border-spacing: 0;
  margin-top: 50px;
  margin-left: auto;
  margin-right: auto;
  width: 95%;
  align-content: start;
  margin-bottom: 200px;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 1px solid #aaa;
}
.sci-inf-thead {
  background: transparent;
  color: #fff;
  padding: 15px;
}
.sci-inf-busqueda {
  color: black;
  display: grid;
  justify-content: start;
  width: 100%;
  grid-template-columns: 1fr;
  position: relative;
}
.sci-inf-busqueda input {
  background: #fff;
  width: 40%;
  height: 25px;
  margin: 0 0 13px 0;
  border-radius: 0px 0 0 0px;
  border: none;
  padding: 0 15px;
  font-size: 0.8em;
  position: relative;
  background: gainsboro;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 1px solid #aaa;
}
.sci-inf-busqueda input:focus {
  outline: 0;
}
.sci-inf-busqueda input::placeholder {
  text-transform: uppercase;
}
.sci-inf-lupa {
  background: #0084ff;
  border: none;
  width: 35px;
  height: 32px;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  position: absolute;
  top: 0;
  left: 37%;
}
.sci-inf-lupa:before {
  display: inline-block;
  content: "";
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid #fff;
  position: relative;
  left: -6px;
  top: -12px;
}
.sci-inf-lupa:after {
  content: "";
  width: 10px;
  height: 2px;
  display: inline-block;
  background: #fff;
  transform: rotate(45deg);
  position: absolute;
  top: 18px;
  left: 17px;
}
.sci-aca-count {
  color: #0d47a1;
  font-size: 1.03rem;
  font-weight: bold;
  display: grid;
  text-align: left;
  padding: 1rem 1rem 1rem 0;
}
.sci-inf-excel {
  font-weight: bold;
  color: #0d47a1;
  font-size: 1.1rem;
  border: 1px solid #ccc;
  padding: 0.4rem;
  margin: 1rem 0 0rem 0;
  border-radius: 5px;
  display: grid;
  width: 100%;
}
.sci-inf-count {
  color: #0d47a1;
  font-size: 1.03rem;
  font-weight: bold;
  display: grid;
  text-align: left;
  padding: 1rem 1rem 1rem 0;
}
.sci-inf-tr1-servicio {
  display: grid;
  grid-template-columns: 2fr 2fr 2fr 2fr 2fr 2fr 2fr 1fr;
  text-transform: uppercase;
  text-align: left;
  font-weight: 100;
  color: #000;
  background-color: gainsboro;
  border-radius: 5px 5px 5px 5px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 5px 5px 5px 5px;
}
.sci-inf-tbody {
  text-align: left;
}
.sci-inf-tr2-servicio {
  display: grid;
  grid-template-columns: 2fr 2fr 2fr 2fr 2fr 2fr 2fr 1fr;
  padding: 10px;
  text-transform: uppercase;
}
.sci-inf-tr2-td {
  cursor: pointer;
  padding: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.active {
  background-color: rgba(0, 132, 255, 1);
  color: rgba(255, 196, 0, 1);
  font-weight: bold;
}
.sci-inf-anchor {
  text-overflow: ellipsis;
  display: flex;
  max-width: 210px;
}
.sci-inf-show {
  width: 96%;
  margin-top: 50px;
  display: grid;
  grid-area: sci-inf-show;
  background: rgba(245, 245, 245, 1) !important;
  border-radius: 0px 10px 0px 10px;
  -webkit-border-radius: 0px 10px 0px 10px;
  text-transform: uppercase;
}
.sci-inf-show2 {
  height: 340px;
}
.sci-inf-nameInf {
  text-align: center;
  width: 90%;
  max-height: 100px;
  margin: 2% auto 0;
  color: rgba(0, 132, 255, 1);
  font-size: 1.3em;
  padding: 5px 0 0 0;
}
.sci-inf-cont-info {
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
}
.sci-inf-inf1-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.sci-inf-info1 {
  display: grid;
  width: 100%;
  margin: 0 auto;
}
.sci-inf-inf1-container {
  padding: 0;
}
.sci-inf-info1 div,
.sci-inf-info2 div {
  padding: 15px 0;
  color: #000;
}
.sci-inf-info1-p1,
.sci-inf-info1-p2,
.sci-inf-info1-p3,
.sci-inf-info1-p4 {
  text-transform: uppercase;
  font-weight: bold;
  color: #000;
}
.sci-inf-info1-3 {
  padding: 0 0 5px 0;
}
.sci-inf-info2 {
  display: grid;
  color: #000;
}
.sci-inf-info2-p1,
.sci-inf-info2-p2,
.sci-inf-info2-p3,
.sci-inf-info2-p4 {
  text-transform: uppercase;
  font-weight: bold;
  color: #000;
}
</style>
